import * as React from "react";
import { connect } from "react-redux";
import { dispatchLogout } from "store/actions/user-context.actions";
import { closePatient } from "store/actions/patient.actions";
import { useTranslation } from "react-i18next";
import { DeleteOptionalTarificationSessionType } from "store/types/tarification.types";
import { Patient } from "model/patient.model";
import { TarificationSessionKey } from "model/tarification-session-key.model";
import { RouteComponentProps, withRouter } from "react-router";
import { deleteOptionalTarificationSession } from "store/actions/tarification.actions";
import { User } from "model/user.model";
import { Button, ListGroup } from "@cc/react-components";
import { TarificationApplicationSession } from "model/tarification.model";

export interface Props extends RouteComponentProps {
  user: User;
  tarificationSession: TarificationApplicationSession;
  patient?: Patient;
  tarificationSessionKey?: TarificationSessionKey;
  setConfirmLogout?: (confirmLogout: boolean) => void;
}

interface DispatchToPropsState {
  closePatient: () => void;
  dispatchLogout: () => void;
  deleteOptionalTarificationSession: DeleteOptionalTarificationSessionType;
}

const ConfirmLogout = ({
  setConfirmLogout,
  user,
  closePatient,
  dispatchLogout,
  deleteOptionalTarificationSession,
  patient,
  tarificationSession,
  tarificationSessionKey,
  history,
}: Props & DispatchToPropsState) => {
  const [t] = useTranslation();
  return (
    <ListGroup>
      <ListGroup.Item className="text-center p-4">
        {t("hamburgerMenu.logOutPhrase", {
          displayName: user.displayName,
        })}
        ?
      </ListGroup.Item>
      <ListGroup.Item>
        <div className={"w-100 d-flex justify-content-around"}>
          <Button
            variant="borderless-secondary"
            onClick={() => {
              !!setConfirmLogout && setConfirmLogout(false);
            }}
          >
            {t("hamburgerMenu.cancel")}
          </Button>
          <Button
            variant="borderless-primary"
            onClick={() => {
              deleteOptionalTarificationSession(
                tarificationSession,
                user.id,
                patient ? patient.id : -1,
                tarificationSessionKey
              );
              closePatient();
              dispatchLogout();
              history.replace("/");
            }}
          >
            {t("hamburgerMenu.confirm")}
          </Button>
        </div>
      </ListGroup.Item>
    </ListGroup>
  );
};

export default connect(null, {
  dispatchLogout,
  closePatient,
  deleteOptionalTarificationSession,
})(withRouter(ConfirmLogout));
